import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import { HighchartsChart, Chart, XAxis, withHighcharts, YAxis, PlotLine, AreaSeries, Tooltip, } from 'react-jsx-highcharts';
// utils
import { getConvertedVerticalDistance, getConvertedDistance } from '../../utils';
import { DateTime } from 'luxon';
const MinLineGraphEl = ({ data, count, startTime, endTime, markedTime, onHoverCB, displayStartTime, displayEndTime, timezone, units, lineColor, }) => {
    const tooltipFormatter = (dist, distVertical, units, time) => `
  <div className="graph-tooltip">
    <div>
      <span class="graph-tooltip_title">AMSL:</span> 
      <span class="graph-tooltip_value">${getConvertedVerticalDistance(distVertical, units.distanceVertical, 0)}</span>
    </div>
    <div>
      <span class="graph-tooltip_title">Dist:</span> 
      <span class="graph-tooltip_value">${getConvertedDistance(dist, units.distance, -1)}</span>
    </div>
    <div>
      <span class="graph-tooltip_title">Time:</span> 
      <span class="graph-tooltip_value">${time}</span>
    </div>
  </div>
  `;
    const [clickedTooltips, setClickedTooltips] = useState([]);
    // Hovered tooltip needs to be in state to reduce flickering during playback
    const [hoveredTooltip, setHoveredTooltip] = useState(null);
    useEffect(() => {
        setHoveredTooltip(React.createElement(Tooltip, { useHTML: true, key: `Hover Tooltip`, formatter: function () {
                const time = DateTime.fromSeconds(Number(startTime) + Number(this.x))
                    .setZone(timezone)
                    .toFormat('HH:mm:ss');
                const dist = data.find(d => d.time === this.x).dist;
                return tooltipFormatter(dist, this.y, units, time);
            }, borderColor: '#c4cdd5', borderWidth: 1, backgroundColor: "white", headerFormat: "", shadow: false, padding: 8, hideDelay: 250, split: false }));
    }, []);
    const plotOptions = {
        line: {
            marker: {
                enabled: false,
            },
        },
        tooltip: {
            enabled: true,
            borderRadius: 3,
        },
        series: {
            turboThreshold: 120000,
            animation: false,
            marker: {
                enabled: false,
            },
            events: {
                mouseOut() {
                    if (onHoverCB) {
                        onHoverCB(null);
                    }
                },
            },
            point: {
                events: {
                    mouseOver() {
                        if (onHoverCB) {
                            onHoverCB(this.x);
                        }
                    },
                    mouseOut() {
                        if (onHoverCB) {
                            onHoverCB(null);
                        }
                    },
                    click() {
                        if (onHoverCB) {
                            onHoverCB(this.x);
                        }
                    },
                },
            },
        },
    };
    const sortedData = data.sort((a, b) => {
        const diff = a.time - b.time;
        return diff > 0 ? 1 : diff < 0 ? -1 : 0;
    });
    const startX = displayStartTime ? displayStartTime - startTime : 0;
    const endX = displayEndTime ? displayEndTime - startTime : endTime - startTime;
    const [chart, setChart] = useState();
    const setChartRef = (chart) => {
        setChart(chart);
    };
    useEffect(() => {
        if (chart) {
            chart.reflow();
        }
    });
    const renderTooltips = (tooltips) => {
        return tooltips.map(item => item);
    };
    // Since Highcharts deals in milliseconds, our max XAxis value is multiplied by 1000.
    return (React.createElement("div", null,
        React.createElement(HighchartsChart, { plotOptions: plotOptions, callback: setChartRef },
            React.createElement(Chart, { type: 'column', spacingTop: 15, height: 72, marginBottom: 0, marginTop: 0, marginLeft: 12, marginRight: 12, padding: 0, scrollablePlotArea: { scrollPositionX: 0 } }),
            React.createElement(XAxis, { id: "distance", min: startX, max: endX, gridLineWidth: 0, tickLength: 0, crosshair: true, labels: { enabled: false } },
                React.createElement(PlotLine, { color: '#0856ca', value: count - startTime, width: 1, zIndex: 5 }),
                markedTime >= 0 && (React.createElement(PlotLine, { color: '#ff0000', value: markedTime, width: 1, zIndex: 5 }))),
            React.createElement(YAxis, { id: "time", gridLineWidth: 0, tickLength: 0, startOnTick: false, labels: { enabled: false } },
                React.createElement(AreaSeries, { data: sortedData.map(d => ({ x: d.time, y: d.alt, d: d.dist })), color: lineColor, onClick: (e) => {
                        // add new tooltip to plot
                        const newTooltip = (React.createElement(Tooltip, { useHTML: true, key: `${e.chartX}`, formatter: function () {
                                const time = DateTime.fromSeconds(Number(startTime) + Number(this.x))
                                    .setZone(timezone)
                                    .toFormat('HH:mm:ss');
                                const dist = data.find(d => d.time === this.x).dist;
                                return tooltipFormatter(dist, this.y, units, time);
                            }, borderColor: '#c4cdd5', borderWidth: 1, backgroundColor: "white", headerFormat: "", shadow: false, padding: 8, hideDelay: 250, split: false, outside: false }));
                        const clickedTooltipArray = clickedTooltips;
                        // Checks to see if click point is close to already existing tooltip
                        const exists = clickedTooltipArray.some(tooltipNode => Number(tooltipNode.key) === e.chartX);
                        if (!exists) {
                            clickedTooltipArray.push(newTooltip);
                            setClickedTooltips(clickedTooltipArray);
                        }
                    } }, renderTooltips(clickedTooltips))),
            hoveredTooltip)));
};
export const MinLineGraph = withHighcharts(MinLineGraphEl, Highcharts);
//# sourceMappingURL=MinLineGraph.js.map